import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { untilDestroyed, UrlParamsService } from '@app/core';
import { UserService, AppService, EnterpriseService } from '@app/services';
import { User } from '@app/models';

@Component({
  selector: 'app-configurations-index',
  templateUrl: './configurations-index.component.html',
  styleUrls: ['./configurations-index.component.scss'],
  standalone: false
})
export class ConfigurationsIndexComponent implements OnInit, OnDestroy {
  currentUser: User;
  page = {
    title: '',
    pathIndex: '',
    path: ''
  };

  constructor(
    public urlParamsService: UrlParamsService,
    public appService: AppService,
    public enterpriseService: EnterpriseService,
    private location: Location,
    private userService: UserService
  ) {
    location.onUrlChange(x => this.urlChange(x));
  }

  ngOnInit() {
    this.userService
      .watchCurrentUser()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: user => (this.currentUser = user)
      });

    this.setCurrent();
  }

  ngOnDestroy() {}

  setCurrent() {
    const page = this.location.path().split('/')[1];

    this.page.pathIndex = page;
    this.page.path = this.location.path();
    this.setCurrentTitle(page);
  }

  setCurrentTitle(url: string) {
    if (url === 'documentos') {
      if (this.location.path().split('/')[2] === 'todos') {
        this.page.title = 'Documentos';
      }
      if (this.location.path().split('/')[2] === 'arquivados') {
        this.page.title = 'Pastas';
      }
    }
    if (url === 'perfil') {
      this.page.title = 'Configurações';
    }
  }

  urlChange(x: string) {
    this.setCurrent();
  }

  showPlanBannerOn(pathArray: string[]) {
    return pathArray.includes(this.page.path);
  }

  canShowOAuthClientsMenu() {
    return this.currentUser?.settings?.developer && this.currentUser?.currentPermissions?.actions_applications_oz;
  }

  canShowAppearanceByDate() {
    // months start from index 0
    const limitDate = new Date(2025, 7, 27);
    const orgDateCreated = new Date(this.currentUser?.organization?.created_at);
    return orgDateCreated <= limitDate;
  }
}
